'use strict';

/**
 * Description of the function
 *
 * @return {String} The string 'myFunction'
 */
var recaptchaFormToRegister = {};
var recaptchaLoaded = false;

var recaptcha = {
	// bind recaptcha to form by selector, there should be element with class 'recaptcha'
	// if element is missing it means that recaptcha is disabled for that form,
	// false returned in that case
	// by default callback will submit a form, otherwise provide callback to handle submit
	initRecaptchaOnForm: function (selector, callback) {
		var recaptchaElement = $(selector).find('.recaptcha');
		callback = callback || function () {
			$(selector).submit();
		};
		// no element for recaptcha provided or it's not configured, return false to allow handler init
		if (recaptchaElement.length < 1 || !window.RECAPTCHA_PUBLIC_KEY) {
			return false;
		}
		// recaptcha script loaded on page, so we can init form handling
		if (window.grecaptcha && recaptchaLoaded) {
			// Add recatcha id to the selector attribute
			var recatchaId = window.grecaptcha.render(recaptchaElement[0], {
				'sitekey': window.RECAPTCHA_PUBLIC_KEY,
				'callback': callback
			});
			recaptchaElement.data('recatchaId', recatchaId);
			return true;
		}
		// store selector and callback to object for delayed submit
		if (!recaptchaFormToRegister[selector]) {
			recaptchaFormToRegister[selector] = callback;
		}
		return true;
	},
	// init recaptcha on forms with delay, executed when recaptcha script loaded
	initRecaptchaForms: function () {
		recaptchaLoaded = true;
		for (var key in recaptchaFormToRegister) {
			window.initRecaptchaOnForm(key, recaptchaFormToRegister[key]);
		}
		recaptchaFormToRegister = {};
	},
	resetRecaptchaForms: function (selector) {
		if (!window.grecaptcha || !recaptchaLoaded) {
			return;
		}

		var recatchaId = null;
		var recaptchaElement = selector ? $(selector).find('.recaptcha') : $('.recaptcha');
		for (var i = 0; i < recaptchaElement.length; i++) {
			recatchaId = $(recaptchaElement[i]).data('recatchaId');
			if (recatchaId !== null) {
				window.grecaptcha.reset(recatchaId);
			}
		}

		if (recatchaId === null) {
			window.grecaptcha.reset();
		}
	}

};

window.initRecaptchaOnForm = recaptcha.initRecaptchaOnForm;
window.initRecaptchaForms = recaptcha.initRecaptchaForms;
module.exports = recaptcha;